import * as React from 'react'
import { Button, ButtonToolbar } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'

import Navbar from '../components/Navbar'
import Loading from '../components/Loading'
import Headline from '../components/Headline'
import UsersQuery from '../components/queries/UsersQuery'
import UsersTable from './usersList/UsersTable'
import StyledContainer from '../components/StyledContainer'
import HeaderContainer from '../components/HeaderContainer'

const UsersList: React.SFC = () => (
  <div>
    <Navbar />
    <StyledContainer>
      <HeaderContainer>
        <Headline>Uživatelé</Headline>
        <ButtonToolbar>
          <LinkContainer to="/users/create">
            <Button id="create-user">Vytvořit uživatele</Button>
          </LinkContainer>
        </ButtonToolbar>
      </HeaderContainer>
      <UsersQuery>
        {({ data, loading, error }) => {
          if (loading) {
            return <Loading />
          }

          if (data == null || error != null) {
            return <div>Error</div>
          }

          return <UsersTable users={data.users} />
        }}
      </UsersQuery>
    </StyledContainer>
  </div>
)

export default UsersList



// WEBPACK FOOTER //
// ./src/screens/UsersList.tsx